import { LanguageKey } from "./language";

export enum PostMessageTypes {
  COPILOT_SESSION = 1,
  USER_PREFERENCES,
}

export interface PostMessage {
  type: PostMessageTypes;
}

export interface PostMessageSession extends PostMessage {
  token: string;
}

export interface PostMessageUserPreference extends PostMessage {
  language: LanguageKey;
  isImperial: boolean;
}
